var _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJcb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2050,
    height: 1579,
    viewBox: "0 0 2050 1579",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2049.22 1260.71C2049.22 1436.07 1906.43 1578.86 1731.07 1578.86H0V318.769C0 143.407 142.794 0.613281 318.155 0.613281H2049.22V1260.71Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1485.56 937.543H1617.08C1620.84 937.543 1629.61 936.29 1633.36 936.29C1658.42 931.28 1679.71 908.733 1679.71 877.419C1679.71 847.357 1658.42 824.81 1633.36 818.547C1629.61 817.295 1622.09 817.295 1617.08 817.295H1485.56V937.543Z",
    fill: "url(#paint0_linear_2258_70004)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1602.05 107.082C1476.79 107.082 1374.08 208.541 1374.08 335.052V571.789H1695.99C1703.51 571.789 1712.28 571.789 1718.54 573.042C1791.19 576.8 1845.05 614.377 1845.05 679.511C1845.05 730.867 1808.73 774.707 1741.09 783.475V785.981C1814.99 790.991 1871.36 832.326 1871.36 896.208C1871.36 965.1 1808.73 1010.19 1726.06 1010.19H1372.83V1473.65H1707.27C1832.53 1473.65 1935.24 1372.19 1935.24 1245.68V107.082H1602.05Z",
    fill: "url(#paint1_linear_2258_70004)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1663.43 694.543C1663.43 664.481 1642.13 644.44 1617.08 640.682C1614.58 640.682 1608.31 639.43 1604.56 639.43H1485.56V749.657H1604.56C1608.31 749.657 1615.83 749.657 1617.08 748.404C1642.13 744.646 1663.43 724.605 1663.43 694.543Z",
    fill: "url(#paint2_linear_2258_70004)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M341.954 107.082C216.696 107.082 113.985 208.541 113.985 335.052V897.46C177.866 928.775 244.253 948.816 310.64 948.816C389.552 948.816 432.14 901.218 432.14 836.084V570.537H627.543V834.831C627.543 937.543 563.661 1021.47 346.965 1021.47C215.444 1021.47 112.732 992.656 112.732 992.656V1472.39H447.171C572.429 1472.39 675.141 1370.94 675.141 1244.43V107.082H341.954Z",
    fill: "url(#paint3_linear_2258_70004)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M972.002 107.082C846.744 107.082 744.033 208.541 744.033 335.052V633.166C801.652 584.315 901.858 553.001 1063.44 560.516C1149.87 564.274 1242.56 588.073 1242.56 588.073V684.522C1196.21 660.723 1141.1 639.429 1069.7 634.418C946.951 625.65 873.049 685.774 873.049 790.991C873.049 897.46 946.951 957.584 1069.7 947.564C1141.1 942.553 1196.21 920.007 1242.56 897.46V993.909C1242.56 993.909 1151.12 1017.71 1063.44 1021.47C901.858 1028.98 801.652 997.667 744.033 948.816V1474.9H1078.47C1203.73 1474.9 1306.44 1373.44 1306.44 1246.93V107.082H972.002Z",
    fill: "url(#paint4_linear_2258_70004)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2258_70004",
    x1: 1373.87,
    y1: 877.569,
    x2: 1936.75,
    y2: 877.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2258_70004",
    x1: 1373.86,
    y1: 789.814,
    x2: 1936.78,
    y2: 789.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2258_70004",
    x1: 1373.86,
    y1: 694.38,
    x2: 1936.75,
    y2: 694.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2258_70004",
    x1: 113.722,
    y1: 789.814,
    x2: 685.312,
    y2: 789.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F286F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#004E94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#0066B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2258_70004",
    x1: 740.789,
    y1: 789.814,
    x2: 1295.94,
    y2: 789.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C2C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173,
    stopColor: "#882730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#BE1833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#DC0436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60039"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcb);
export default __webpack_public_path__ + "static/media/jcb.31fd0724.svg";
export { ForwardRef as ReactComponent };